import Column from '@components/Column';
import SortItems from '@components/Filter/SortItems';
import styled from '@emotion/styled';
import { useContext } from 'react';

import FilterContext from './context/FilterContext';
import FilterItems from './FilterItems';

function FilterBottomSheetContents() {
    const { sortItems, filterItems } = useContext(FilterContext);

    return (
        <Container spacing={16}>
            <FilterItems/>
            {(sortItems && filterItems) && (<Divider/>)}
            <SortItems/>
        </Container>
    );
}

const Container = styled(Column)`
    padding:24px 20px 50px;
`;

const Divider = styled.div`
    background-color: var(--color-gray3);
    height: 1px;
    width: 100%;
`;

export default FilterBottomSheetContents;
